module.exports = __webpack_public_path__ + "static/media/16.7fe0bb58.png";